import React from "react";
import AdvancedManagementInfoStep from "../template/AdvancedManagementInfoStep";
import clock from "../../../../img/advanced-management/clock.svg";

const AdvancedManagementHasBeenReached = () => {
	return (
		<AdvancedManagementInfoStep
			dataImg={clock}
			dataText={
				<React.Fragment>
					<strong>Você excedeu o limite de 3 tentativas por dia. </strong>
					<br />
					<p>
						Aguarde até que a indicação de participantes esteja disponível para você
						novamente.
					</p>
				</React.Fragment>
			}
		/>
	);
};

export default AdvancedManagementHasBeenReached;
